export { DEFAULT_DOC_MODE } from './constants';
export { Doc } from './entities/doc';
export { DocRecord } from './entities/record';
export { DocRecordList } from './entities/record-list';
export { DocCreated } from './events';
export {
  type EdgelessDocItem,
  useWorkspaceEdgelessDocs,
} from './hooks/use-workspace-edgeless-docs';
export { DocScope } from './scopes/doc';
export { DocService } from './services/doc';
export { DocMutationService } from './services/doc-mutation-service';
export { DocPermissionService } from './services/doc-permission';
export {
  CREATE_DOC_PERMISSION_ERROR,
  DocsService,
  isCreateDocPermissionError,
} from './services/docs';

import type { Framework } from '@toeverything/infra';

// Direct import to avoid circular dependency:
// doc → cloud/index → cloud/blocksuite-writer-info → workspace → doc
import { WorkspaceServerService } from '../cloud/services/workspace-server';
import { WorkspaceDBService } from '../db/services/db';
import { GuardService } from '../permissions/services/guard';
import { WorkspacePermissionService } from '../permissions/services/permission';
import { PermissionSnapshotStore } from '../permissions/stores/permission-snapshot';
import { GlobalState } from '../storage';
// Direct import to avoid circular dependency (doc → tag/index → doc)
import { TagStore } from '../tag/stores/tag';
// Direct import to avoid circular dependency with workbench barrel
import { WorkbenchService } from '../workbench/services/workbench';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { Doc } from './entities/doc';
import { DocRecord } from './entities/record';
import { DocRecordList } from './entities/record-list';
import { DocCreateMiddleware } from './providers/doc-create-middleware';
import { DocScope } from './scopes/doc';
import { DocService } from './services/doc';
import { DocMutationService } from './services/doc-mutation-service';
import { DocPermissionService } from './services/doc-permission';
import { DocsService } from './services/docs';
import { AccessibleDocCacheStore } from './stores/accessible-doc-cache';
import { DocPropertiesStore } from './stores/doc-properties';
import { DocsStore } from './stores/docs';

export { DocCreateMiddleware } from './providers/doc-create-middleware';

export function configureDocModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(DocsService, [
      DocsStore,
      DocPropertiesStore,
      [DocCreateMiddleware],
      WorkspaceService,
      WorkspacePermissionService,
      WorkspaceServerService,
    ])
    .store(DocPropertiesStore, [WorkspaceService, WorkspaceDBService])
    .store(AccessibleDocCacheStore, [
      WorkspaceService,
      WorkspaceServerService,
      GlobalState,
      PermissionSnapshotStore,
    ])
    .service(DocMutationService, [
      WorkspaceService,
      WorkspaceServerService,
      AccessibleDocCacheStore,
    ])
    .service(DocPermissionService, [
      AccessibleDocCacheStore,
      WorkbenchService,
      GuardService,
    ])
    .store(DocsStore, [
      WorkspaceService,
      DocPropertiesStore,
      AccessibleDocCacheStore,
      TagStore,
      DocMutationService,
      PermissionSnapshotStore,
    ])
    .entity(DocRecord, [DocsStore, DocPropertiesStore])
    .entity(DocRecordList, [DocsStore])
    .scope(DocScope)
    .entity(Doc, [DocScope, DocsStore, WorkspaceService])
    .service(DocService);
}
